import { createStore } from 'satcheljs';
import { WeatherStore } from './schema/WeatherStore';

let weatherStoreData: WeatherStore = {
    isValid: false,
    weatherLocations: null,
    currentLocationIndex: 0,
    pollingWindowInMinutes: 0,
};

let weatherStore = createStore<WeatherStore>('weatherStore', weatherStoreData)();
export default weatherStore;
